(function () {
  'use strict';

  var overlay;
  var fflInitialized = false;

  function $(selector, root) { return (root || document).querySelector(selector); }
  function setValue(selector, value) { var el = $(selector); if (el) el.value = value || ''; }

  function setButtonState() {
    var phone = $('#mobile').value.replace(/\D/g, '');
    var hasDealer = Boolean(overlay.dataset.fflNumber);
    $('.proceed_btn').disabled = !(hasDealer && /^\d{10}$/.test(phone));
  }

  function validatePhone(showError) {
    var phone = $('#mobile').value.replace(/\D/g, '').slice(0, 10);
    $('#mobile').value = phone;
    $('#mobile-error').textContent = showError && phone.length !== 10 ? 'Please enter a valid 10-digit phone number.' : '';
    setButtonState();
  }

  window.getSelected = function (data) {
    data = data || {};
    setValue('.license_name-cus', data.license_name);
    setValue('.premise_city-cus', data.premise_city);
    setValue('.premise_state-cus', data.premise_state);
    setValue('.premise_street-cus', data.premise_street);
    setValue('.premise_zip_code-cus', data.premise_zip_code);
    setValue('.voice_phone-cus', data.voice_phone);

    if (!data.license_number) return;
    var location = [data.license_name, data.premise_street, data.premise_city, data.premise_state, data.premise_zip_code].filter(Boolean).join(', ');
    overlay.dataset.location = location;
    overlay.dataset.fflNumber = data.license_number;
    overlay.dataset.fflAll = JSON.stringify(data);
    $('#fflSelectedDealerText').textContent = location + ' · FFL ' + data.license_number;
    $('#fflSelectedDealer').hidden = false;
    $('#fflDealerStatus').textContent = 'Selected';
    $('#fflDealerStatus').classList.add('is-selected');
    setButtonState();
  };

  function openPopup(trigger) {
    var cartItem = trigger.closest('.cst_cart_item');
    var quantityInput = cartItem ? $('.quantity__input', cartItem) : null;
    overlay.dataset.id = trigger.dataset.id || '';
    overlay.dataset.qty = quantityInput ? quantityInput.value : '1';
    overlay.dataset.key = trigger.dataset.key || '';
    overlay.dataset.apiType = trigger.dataset.apiType || '';
    overlay.dataset.apiName = trigger.dataset.apiName || '';
    overlay.dataset.apiProfileType = trigger.dataset.apiProfileType || '';
    overlay.dataset.fflNumber = '';
    overlay.dataset.location = '';
    overlay.dataset.fflAll = '';
    $('#mobile').value = '';
    $('#mobile-error').textContent = '';
    $('#fflSelectedDealer').hidden = true;
    $('#fflDealerStatus').textContent = 'Not selected';
    $('#fflDealerStatus').classList.remove('is-selected');
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ffl_pop_added');
    $('.cst_closePopup').focus();
    initializeFflFinder();
  }

  function initializeFflFinder() {
    if (fflInitialized) return;
    if (!window.FFL || typeof window.FFL.init !== 'function') {
      $('#fflSubmitError').textContent = 'The FFL finder could not load. Please refresh the page.';
      return;
    }
    fflInitialized = true;
    window.FFL.init({
      container: 'ffl_container',
      apiKey: 'vlgFUaAUY2woJ35TBhvIJU9uMytkoanEPM2uwmA5L1kqcpoxThSJrDuXoxVtQaNo67474f230ac0f',
      geoKey: 'AIzaSyDFRMcJvNVV5-scB4IRZmev1lJ6wnrMPtw',
      cBack: window.getSelected
    });
    observeFflResults();
  }

  function observeFflResults() {
    var container = $('#ffl_container');
    var list = $('#ffl-list');
    if (!container || !list) return;

    function syncLayout() {
      container.classList.toggle('ffl_hasResults', !list.classList.contains('ffl-hide'));
    }

    syncLayout();
    new MutationObserver(syncLayout).observe(list, { attributes: true, attributeFilter: ['class'] });
  }

  function closePopup() {
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ffl_pop_added');
  }

  async function saveLineItem() {
    validatePhone(true);
    if ($('.proceed_btn').disabled) return;

    var button = $('.proceed_btn');
    var buttonText = $('.btn_text', button);
    var errorBox = $('#fflSubmitError');
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    buttonText.textContent = 'Saving…';
    errorBox.textContent = '';

    var formData = new FormData();
    formData.append('id', overlay.dataset.key);
    formData.append('quantity', overlay.dataset.qty || '1');
    formData.append('properties[FFL]', overlay.dataset.fflNumber.replace(/-/g, ''));
    formData.append('properties[PHONE]', $('#mobile').value);
    formData.append('properties[_API_TYPE]', overlay.dataset.apiName || '');
    formData.append('properties[_PRODUCT_TYPE]', overlay.dataset.apiType || '');
    formData.append('properties[_API_PROFILE_TYPE]', overlay.dataset.apiProfileType || '');
    formData.append('properties[_FFL_ALL]', overlay.dataset.fflAll || '{}');

    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/change.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      if (!response.ok) { var body = await response.json().catch(function () { return {}; }); throw new Error(body.description || 'Could not update the cart item.'); }
      window.location.reload();
    } catch (error) {
      errorBox.textContent = 'Unable to save: ' + error.message + ' Please check your details and try again.';
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      buttonText.textContent = 'Save & continue';
      setButtonState();
    }
  }

  function init() {
    overlay = $('#cst_popupOverlay');
    if (!overlay) return;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.cst_openPopup');
      if (trigger) openPopup(trigger);
      if (event.target === overlay || event.target.closest('#cst_closePopup')) closePopup();
    });
    $('#mobile').addEventListener('input', function () { validatePhone(false); });
    $('#mobile').addEventListener('blur', function () { validatePhone(true); });
    $('.proceed_btn').addEventListener('click', saveLineItem);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closePopup(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
